module.exports = __webpack_public_path__ + "img/secure-bg.427a850e.svg";